import React from 'react';

function BlogPost(props) {
    return(
        <div className='blogpost'>
            <h2>{props.title}</h2>
            <p>{props.text}</p>
            <a href={(props.linkToMedium) ? props.linkToMedium : '#'}>
                <div className="read-on-medium">

                <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M27.6062 2.91625L30 0.62625V0.125H21.7075L15.7975 14.835L9.07375 0.125H0.37875V0.62625L3.175 3.9925C3.4475 4.24125 3.59 4.605 3.55375 4.97125V18.2C3.64 18.6763 3.485 19.1663 3.15 19.5125L0 23.33V23.825H8.93125V23.3238L5.78125 19.5125C5.44 19.165 5.27875 18.6838 5.3475 18.2V6.7575L13.1875 23.8313H14.0988L20.84 6.7575V20.3588C20.84 20.7175 20.84 20.7913 20.605 21.0263L18.18 23.3725V23.875H29.945V23.3738L27.6075 21.085C27.4025 20.93 27.2962 20.67 27.34 20.4175V3.58375C27.2962 3.33 27.4012 3.07 27.6062 2.91625Z" fill="#212121"/>
                </svg>

                <p className='bold underline'>Read on Medium</p>

                <svg width="45" height="18" viewBox="0 0 45 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 9H43.5M43.5 9L35.5 1M43.5 9L35.5 17" stroke="black" stroke-width="2"/>
                </svg>


                </div> {/* .read-on-medium */}
            </a>

            <hr className='blogpost-separator'/>

            <div className="blogpost-info">
                <div className="read-time">{props.readTime} min read</div>
                <div className="post-date">{props.postDate}</div>
            </div>

        </div>
    )
}

export default BlogPost;